import { Skeleton } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    skeletonCard: {
        height: "12rem",
        minWidth: "17.5rem",
        borderRadius: ".75rem",
    },
}))

export const MenuSkeleton = () => {
    const { classes } = useStyles()

    return (
        <>
            <Skeleton variant="rectangular" className={classes.skeletonCard} />
            <Skeleton variant="rectangular" className={classes.skeletonCard} />
            <Skeleton variant="rectangular" className={classes.skeletonCard} />
        </>
    )
}
